import React, { Component } from 'react';
import BloxButton from 'sub_components/Common/BloxButton';
import AddPreference from '../Contact/AddPreference';

const CDN_URL = process.env.REACT_APP_CDN_URL;

const emailDefault = `${CDN_URL}common/email-icon-default-lg.svg`;
const emailSelected = `${CDN_URL}common/email-icon-selected-lg.svg`;
const phoneDefault = `${CDN_URL}common/phone-icon-default-lg.svg`;
const phoneSelected = `${CDN_URL}common/phone-mobile-icon-selected-lg.svg`;

class ContactSelectionEdit extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preference: null,
			emails: [],
			email: null,
			numbers: [],
		};
	}

	onMouseEnter = id => {
		const icon = document.getElementById(id);

		if (id === 'phone') {
			icon.src = phoneSelected;
		} else {
			icon.src = emailSelected;
		}
	};
	onMouseLeave = (id, typeIcon) => {
		const icon = document.getElementById(id);
		icon.src = typeIcon;
	};
	preferenceSelected = preference => {
		this.setState({ preference });
	};
	onChange = event => {
		const { value } = event.target;
		this.setState({ [event.target.name]: value });
	};

	componentDidMount() {
		const { auth_status } = this.props;
		const {
			user: {
				contactDetails: { email, mobile_number, phone_number },
			},
		} = auth_status;
		const numbers = [mobile_number, phone_number];
		const emails = [email];
		this.setState({ emails, numbers });
	}

	updateEditParams = (preference, data) => {
		const { updateData, closeEditModal } = this.props;

		updateData('contact', null, { preference, data });

		closeEditModal();
	};

	onFieldComplete = (field, isValid) => {
		const { fieldCompleted } = this.state;

		if (isValid) {
			this.setState({ fieldCompleted: true });
		} else {
			if (fieldCompleted) {
				this.setState({ fieldCompleted: false });
			}
		}
	};
	setSelected = item => {
		this.setState({ selected: item });
	};
	checkEnabled = () => {
		const { selected, fieldCompleted } = this.state;
		if (selected === 'custom' && fieldCompleted) {
			return true;
		} else if (selected === 'custom' && !fieldCompleted) {
			return false;
		} else if (!selected && selected !== 'custom') {
			return false;
		} else {
			return true;
		}
	};
	render() {
		const { preference, emails, numbers, selected, email, phone } = this.state;

		const phoneIcon = preference === 'phone' ? phoneSelected : phoneDefault;
		const emailIcon = preference === 'email' ? emailSelected : emailDefault;
		const preferenceTitle = `OK.Now pick a different ${preference} or add a new one.`;
		const enabled = this.checkEnabled();
		const userInput = preference === 'email' ? email : phone;

		return (
			<div className='contact-selection-stage edit'>
				<div className='title heading60'>
					{preference ? preferenceTitle : 'Choose a different contact method?'}
				</div>
				{!preference && (
					<div className={'contact-selection-wrapper'}>
						<div
							className='contact-selection'
							onClick={() => {
								this.preferenceSelected('email');
							}}
							onMouseEnter={() => this.onMouseEnter('email')}
							onMouseLeave={() => this.onMouseLeave('email', emailIcon)}
						>
							<img src={emailIcon} id='email' />
							<div className='title heading76'>Email</div>
						</div>

						<div
							className={`contact-selection`}
							onClick={() => {
								this.preferenceSelected('phone');
							}}
							onMouseEnter={() => this.onMouseEnter('phone')}
							onMouseLeave={() => this.onMouseLeave('phone', phoneIcon)}
						>
							<img src={phoneIcon} id='phone' />
							<div className='title heading76'>Phone</div>
						</div>
					</div>
				)}
				{preference === 'email' && (
					<AddPreference
						preference={preference}
						iconActive={emailSelected}
						iconDefault={emailDefault}
						data={emails}
						onChange={this.onChange}
						setSelected={this.setSelected}
						selected={selected}
						onFieldComplete={this.onFieldComplete}
						email={email}
						phase='edit'
					/>
				)}
				{preference === 'phone' && (
					<AddPreference
						preference={preference}
						iconActive={phoneSelected}
						iconDefault={phoneDefault}
						data={numbers}
						onChange={this.onChange}
						setSelected={this.setSelected}
						selected={selected}
						onFieldComplete={this.onFieldComplete}
						email={email}
						phase='edit'
					/>
				)}
				<div className='buttons-wrapper'>
					{preference && (
						<div className='next-button'>
							<BloxButton
								title='DONE'
								enabled={enabled}
								customClass={enabled ? 'blox-button-swipe active' : 'blox-button-swipe'}
								onClick={
									selected === 'custom'
										? () => this.updateEditParams(preference, userInput)
										: () => this.updateEditParams(preference, selected)
								}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default ContactSelectionEdit;
